import { ValidatorType } from "../../../../../types/ValidatorType";
import { isEmail } from "../../../../../services/validationRules";

export const emailDefaultInformal: ValidatorType = {
  validator: isEmail,
  message: "Bitte gib eine gültige E-Mail-Adresse an",
};
